/**
 * @desc 获取明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.defaultShopInfo.getDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/defaultShopInfo/getDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
